function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n2 = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n2 >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n2++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { Plugin as b } from "../../../../../@ckeditor_ckeditor5-core@45.2.1/node_modules/@ckeditor/ckeditor5-core/dist/index.js";
import { EventInfo as q, uid as z, delay as j, DomEmitterMixin as A, env as f, global as m, createElement as x, Rect as _, getRangeFromMouseEvent as ee, ResizeObserver as te, toUnit as re } from "../../../../../@ckeditor_ckeditor5-utils@45.2.1/node_modules/@ckeditor/ckeditor5-utils/dist/index.js";
import { MouseObserver as ne, LiveRange as T, DomEventObserver as ie, DataTransfer as oe, Range as se } from "../../../../../@ckeditor_ckeditor5-engine@45.2.1/node_modules/@ckeditor/ckeditor5-engine/dist/index.js";
import { Widget as ae, isWidget as k } from "../../../../../@ckeditor_ckeditor5-widget@45.2.1/node_modules/@ckeditor/ckeditor5-widget/dist/index.js";
import { View as le } from "../../../../../@ckeditor_ckeditor5-ui@45.2.1/node_modules/@ckeditor/ckeditor5-ui/dist/index.js";
import { mapValues as ce } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/object/mapValues.js";
import { throttle as V } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/function/throttle.js"; /**
                                                                                                                           * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
                                                                                                                           * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
                                                                                                                           */
var v = /*#__PURE__*/function (_ie) {
  function v(e) {
    var _this;
    _classCallCheck(this, v);
    _this = _callSuper(this, v, [e]);
    _defineProperty(_this, "domEventType", ["paste", "copy", "cut", "drop", "dragover", "dragstart", "dragend", "dragenter", "dragleave"]);
    var t = _this.document;
    _this.listenTo(t, "paste", r("clipboardInput"), {
      priority: "low"
    }), _this.listenTo(t, "drop", r("clipboardInput"), {
      priority: "low"
    }), _this.listenTo(t, "dragover", r("dragging"), {
      priority: "low"
    });
    function r(n) {
      return function (s, o) {
        o.preventDefault();
        var i = o.dropRange ? [o.dropRange] : null,
          l = new q(t, n);
        t.fire(l, {
          dataTransfer: o.dataTransfer,
          method: s.name,
          targetRanges: i,
          target: o.target,
          domEvent: o.domEvent
        }), l.stop.called && o.stopPropagation();
      };
    }
    return _this;
  }
  _inherits(v, _ie);
  return _createClass(v, [{
    key: "onDomEvent",
    value: function onDomEvent(e) {
      var t = "clipboardData" in e ? e.clipboardData : e.dataTransfer,
        r = e.type == "drop" || e.type == "paste",
        n = {
          dataTransfer: new oe(t, {
            cacheFiles: r
          })
        };
      if (e.type == "drop" || e.type == "dragover") {
        var s = ee(e);
        n.dropRange = s && this.view.domConverter.domRangeToView(s);
      }
      this.fire(e.type, e, n);
    }
  }]);
}(ie);
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
function de(a) {
  return a = a.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r?\n\r?\n/g, "</p><p>").replace(/\r?\n/g, "<br>").replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;").replace(/^\s/, "&nbsp;").replace(/\s$/, "&nbsp;").replace(/\s\s/g, " &nbsp;"), (a.includes("</p><p>") || a.includes("<br>")) && (a = "<p>".concat(a, "</p>")), a;
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function ge(a) {
  return a.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, function (e, t) {
    return t.length == 1 ? " " : t;
  }).replace(/<!--[\s\S]*?-->/g, "");
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
var B = ["figcaption", "li"],
  L = ["ol", "ul"];
function H(a, e) {
  if (e.is("$text") || e.is("$textProxy")) return e.data;
  if (e.is("element", "img") && e.hasAttribute("alt")) return e.getAttribute("alt");
  if (e.is("element", "br")) return "\n";
  var t = "",
    r = null;
  var _iterator = _createForOfIteratorHelper(e.getChildren()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _n = _step.value;
      t += pe(_n, r) + H(a, _n), r = _n;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (e.is("rawElement")) {
    var n = document.createElement("div");
    e.render(n, a), t += K(n);
  }
  return t;
}
function K(a) {
  var e = "";
  if (a.nodeType === Node.TEXT_NODE) return a.textContent;
  if (a.tagName === "BR") return "\n";
  var _iterator2 = _createForOfIteratorHelper(a.childNodes),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var t = _step2.value;
      e += K(t);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return e;
}
function pe(a, e) {
  return e ? a.is("element", "li") && !a.isEmpty && a.getChild(0).is("containerElement") || L.includes(a.name) && L.includes(e.name) ? "\n\n" : !a.is("containerElement") && !e.is("containerElement") ? "" : B.includes(a.name) || B.includes(e.name) ? "\n" : a.is("element") && a.getCustomProperty("dataPipeline:transparentRendering") || e.is("element") && e.getCustomProperty("dataPipeline:transparentRendering") ? "" : "\n\n" : "";
}
var G = /*#__PURE__*/function (_b) {
  function G() {
    var _this2;
    _classCallCheck(this, G);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, G, [].concat(args));
    _defineProperty(_this2, "_markersToCopy", new Map());
    return _this2;
  }
  _inherits(G, _b);
  return _createClass(G, [{
    key: "_registerMarkerToCopy",
    value: function _registerMarkerToCopy(e, t) {
      this._markersToCopy.set(e, t);
    }
  }, {
    key: "_copySelectedFragmentWithMarkers",
    value: function _copySelectedFragmentWithMarkers(e, t) {
      var _this3 = this;
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (n) {
        return n.model.getSelectedContent(n.model.document.selection);
      };
      return this.editor.model.change(function (n) {
        var s = n.model.document.selection;
        n.setSelection(t);
        var o = _this3._insertFakeMarkersIntoSelection(n, n.model.document.selection, e),
          i = r(n),
          l = _this3._removeFakeMarkersInsideElement(n, i);
        for (var _i = 0, _Object$entries = Object.entries(o); _i < _Object$entries.length; _i++) {
          var _ref = _Object$entries[_i];
          var _ref2 = _slicedToArray(_ref, 2);
          var c = _ref2[0];
          var d = _ref2[1];
          l[c] || (l[c] = n.createRangeIn(i));
          var _iterator3 = _createForOfIteratorHelper(d),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var g = _step3.value;
              n.remove(g);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
        i.markers.clear();
        for (var _i2 = 0, _Object$entries2 = Object.entries(l); _i2 < _Object$entries2.length; _i2++) {
          var _ref3 = _Object$entries2[_i2];
          var _ref4 = _slicedToArray(_ref3, 2);
          var _c = _ref4[0];
          var _d = _ref4[1];
          i.markers.set(_c, _d);
        }
        return n.setSelection(s), i;
      });
    }
  }, {
    key: "_pasteMarkersIntoTransformedElement",
    value: function _pasteMarkersIntoTransformedElement(e, t) {
      var _this4 = this;
      var r = this._getPasteMarkersFromRangeMap(e);
      return this.editor.model.change(function (n) {
        var s = _this4._insertFakeMarkersElements(n, r),
          o = t(n),
          i = _this4._removeFakeMarkersInsideElement(n, o);
        var _iterator4 = _createForOfIteratorHelper(Object.values(s).flat()),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _l = _step4.value;
            n.remove(_l);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        for (var _i3 = 0, _Object$entries3 = Object.entries(i); _i3 < _Object$entries3.length; _i3++) {
          var _ref5 = _Object$entries3[_i3];
          var _ref6 = _slicedToArray(_ref5, 2);
          var l = _ref6[0];
          var c = _ref6[1];
          n.model.markers.has(l) || n.addMarker(l, {
            usingOperation: !0,
            affectsData: !0,
            range: c
          });
        }
        return o;
      });
    }
  }, {
    key: "_pasteFragmentWithMarkers",
    value: function _pasteFragmentWithMarkers(e) {
      var t = this._getPasteMarkersFromRangeMap(e.markers);
      e.markers.clear();
      var _iterator5 = _createForOfIteratorHelper(t),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var r = _step5.value;
          e.markers.set(r.name, r.range);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return this.editor.model.insertContent(e);
    }
  }, {
    key: "_forceMarkersCopy",
    value: function _forceMarkersCopy(e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        allowedActions: "all",
        copyPartiallySelected: !0,
        duplicateOnPaste: !0
      };
      var n = this._markersToCopy.get(e);
      this._markersToCopy.set(e, r), t(), n ? this._markersToCopy.set(e, n) : this._markersToCopy.delete(e);
    }
  }, {
    key: "_isMarkerCopyable",
    value: function _isMarkerCopyable(e, t) {
      var r = this._getMarkerClipboardConfig(e);
      if (!r) return !1;
      if (!t) return !0;
      var n = r.allowedActions;
      return n === "all" || n.includes(t);
    }
  }, {
    key: "_hasMarkerConfiguration",
    value: function _hasMarkerConfiguration(e) {
      return !!this._getMarkerClipboardConfig(e);
    }
  }, {
    key: "_getMarkerClipboardConfig",
    value: function _getMarkerClipboardConfig(e) {
      var _e$split = e.split(":"),
        _e$split2 = _slicedToArray(_e$split, 1),
        t = _e$split2[0];
      return this._markersToCopy.get(t) || null;
    }
  }, {
    key: "_insertFakeMarkersIntoSelection",
    value: function _insertFakeMarkersIntoSelection(e, t, r) {
      var n = this._getCopyableMarkersFromSelection(e, t, r);
      return this._insertFakeMarkersElements(e, n);
    }
  }, {
    key: "_getCopyableMarkersFromSelection",
    value: function _getCopyableMarkersFromSelection(e, t, r) {
      var _this5 = this;
      var n = Array.from(t.getRanges()),
        s = new Set(n.flatMap(function (i) {
          return Array.from(e.model.markers.getMarkersIntersectingRange(i));
        })),
        o = function o(i) {
          if (!_this5._isMarkerCopyable(i.name, r)) return !1;
          var _this5$_getMarkerClip = _this5._getMarkerClipboardConfig(i.name),
            c = _this5$_getMarkerClip.copyPartiallySelected;
          if (!c) {
            var d = i.getRange();
            return n.some(function (g) {
              return g.containsRange(d, !0);
            });
          }
          return !0;
        };
      return Array.from(s).filter(o).map(function (i) {
        return {
          name: r === "dragstart" ? _this5._getUniqueMarkerName(i.name) : i.name,
          range: i.getRange()
        };
      });
    }
  }, {
    key: "_getPasteMarkersFromRangeMap",
    value: function _getPasteMarkersFromRangeMap(e) {
      var _this6 = this;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var r = this.editor.model;
      return (e instanceof Map ? Array.from(e.entries()) : Object.entries(e)).flatMap(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
          s = _ref8[0],
          o = _ref8[1];
        if (!_this6._hasMarkerConfiguration(s)) return [{
          name: s,
          range: o
        }];
        if (_this6._isMarkerCopyable(s, t)) {
          var i = _this6._getMarkerClipboardConfig(s),
            l = r.markers.has(s) && r.markers.get(s).getRange().root.rootName === "$graveyard";
          return (i.duplicateOnPaste || l) && (s = _this6._getUniqueMarkerName(s)), [{
            name: s,
            range: o
          }];
        }
        return [];
      });
    }
  }, {
    key: "_insertFakeMarkersElements",
    value: function _insertFakeMarkersElements(e, t) {
      var r = {},
        n = t.flatMap(function (s) {
          var _s$range = s.range,
            o = _s$range.start,
            i = _s$range.end;
          return [{
            position: o,
            marker: s,
            type: "start"
          }, {
            position: i,
            marker: s,
            type: "end"
          }];
        }).sort(function (_ref9, _ref0) {
          var s = _ref9.position;
          var o = _ref0.position;
          return s.isBefore(o) ? 1 : -1;
        });
      var _iterator6 = _createForOfIteratorHelper(n),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _ref1 = _step6.value;
          var s = _ref1.position;
          var o = _ref1.marker;
          var i = _ref1.type;
          var l = e.createElement("$marker", {
            "data-name": o.name,
            "data-type": i
          });
          r[o.name] || (r[o.name] = []), r[o.name].push(l), e.insert(l, s);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return r;
    }
  }, {
    key: "_removeFakeMarkersInsideElement",
    value: function _removeFakeMarkersInsideElement(e, t) {
      var _this7 = this;
      var n = this._getAllFakeMarkersFromElement(e, t).reduce(function (s, o) {
        var _l2, _l3;
        var i = o.markerElement && e.createPositionBefore(o.markerElement);
        var l = s[o.name],
          c = !1;
        return (_l2 = l) !== null && _l2 !== void 0 && _l2.start && (_l3 = l) !== null && _l3 !== void 0 && _l3.end && (_this7._getMarkerClipboardConfig(o.name).duplicateOnPaste ? s[_this7._getUniqueMarkerName(o.name)] = s[o.name] : c = !0, l = null), c || (s[o.name] = _objectSpread(_objectSpread({}, l), {}, _defineProperty({}, o.type, i))), o.markerElement && e.remove(o.markerElement), s;
      }, {});
      return ce(n, function (s) {
        return new se(s.start || e.createPositionFromPath(t, [0]), s.end || e.createPositionAt(t, "end"));
      });
    }
  }, {
    key: "_getAllFakeMarkersFromElement",
    value: function _getAllFakeMarkersFromElement(e, t) {
      var r = Array.from(e.createRangeIn(t)).flatMap(function (_ref10) {
          var o = _ref10.item;
          if (!o.is("element", "$marker")) return [];
          var i = o.getAttribute("data-name"),
            l = o.getAttribute("data-type");
          return [{
            markerElement: o,
            name: i,
            type: l
          }];
        }),
        n = [],
        s = [];
      var _iterator7 = _createForOfIteratorHelper(r),
        _step7;
      try {
        var _loop = function _loop() {
          var o = _step7.value;
          o.type === "end" && (r.some(function (l) {
            return l.name === o.name && l.type === "start";
          }) || n.push({
            markerElement: null,
            name: o.name,
            type: "start"
          })), o.type === "start" && (r.some(function (l) {
            return l.name === o.name && l.type === "end";
          }) || s.unshift({
            markerElement: null,
            name: o.name,
            type: "end"
          }));
        };
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      return [].concat(n, _toConsumableArray(r), s);
    }
  }, {
    key: "_getUniqueMarkerName",
    value: function _getUniqueMarkerName(e) {
      var t = e.split(":"),
        r = z().substring(1, 6);
      return t.length === 3 ? "".concat(t.slice(0, 2).join(":"), ":").concat(r) : "".concat(t.join(":"), ":").concat(r);
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "ClipboardMarkersUtils";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(b);
var y = /*#__PURE__*/function (_b2) {
  function y() {
    _classCallCheck(this, y);
    return _callSuper(this, y, arguments);
  }
  _inherits(y, _b2);
  return _createClass(y, [{
    key: "init",
    value: function init() {
      this.editor.editing.view.addObserver(v), this._setupPasteDrop(), this._setupCopyCut();
    }
  }, {
    key: "_fireOutputTransformationEvent",
    value: function _fireOutputTransformationEvent(e, t, r) {
      var _this8 = this;
      var n = this.editor.plugins.get("ClipboardMarkersUtils");
      this.editor.model.enqueueChange({
        isUndoable: r === "cut"
      }, function () {
        var s = n._copySelectedFragmentWithMarkers(r, t);
        _this8.fire("outputTransformation", {
          dataTransfer: e,
          content: s,
          method: r
        });
      });
    }
  }, {
    key: "_setupPasteDrop",
    value: function _setupPasteDrop() {
      var _this9 = this;
      var e = this.editor,
        t = e.model,
        r = e.editing.view,
        n = r.document,
        s = this.editor.plugins.get("ClipboardMarkersUtils");
      this.listenTo(n, "clipboardInput", function (o, i) {
        i.method == "paste" && !e.model.canEditAt(e.model.document.selection) && o.stop();
      }, {
        priority: "highest"
      }), this.listenTo(n, "clipboardInput", function (o, i) {
        var l = i.dataTransfer;
        var c;
        if (i.content) c = i.content;else {
          var p = "";
          l.getData("text/html") ? p = ge(l.getData("text/html")) : l.getData("text/plain") && (p = de(l.getData("text/plain"))), c = _this9.editor.data.htmlProcessor.toView(p);
        }
        var d = new q(_this9, "inputTransformation"),
          g = l.getData("application/ckeditor5-editor-id") || null;
        _this9.fire(d, {
          content: c,
          dataTransfer: l,
          sourceEditorId: g,
          targetRanges: i.targetRanges,
          method: i.method
        }), d.stop.called && o.stop(), r.scrollToTheSelection();
      }, {
        priority: "low"
      }), this.listenTo(this, "inputTransformation", function (o, i) {
        if (i.content.isEmpty) return;
        var c = _this9.editor.data.toModel(i.content, "$clipboardHolder");
        c.childCount != 0 && (o.stop(), t.change(function () {
          _this9.fire("contentInsertion", {
            content: c,
            method: i.method,
            sourceEditorId: i.sourceEditorId,
            dataTransfer: i.dataTransfer,
            targetRanges: i.targetRanges
          });
        }));
      }, {
        priority: "low"
      }), this.listenTo(this, "contentInsertion", function (o, i) {
        i.resultRange = s._pasteFragmentWithMarkers(i.content);
      }, {
        priority: "low"
      });
    }
  }, {
    key: "_setupCopyCut",
    value: function _setupCopyCut() {
      var _this0 = this;
      var e = this.editor,
        t = e.model.document,
        n = e.editing.view.document,
        s = function s(o, i) {
          var l = i.dataTransfer;
          i.preventDefault(), _this0._fireOutputTransformationEvent(l, t.selection, o.name);
        };
      this.listenTo(n, "copy", s, {
        priority: "low"
      }), this.listenTo(n, "cut", function (o, i) {
        e.model.canEditAt(e.model.document.selection) ? s(o, i) : i.preventDefault();
      }, {
        priority: "low"
      }), this.listenTo(this, "outputTransformation", function (o, i) {
        var l = e.data.toView(i.content, {
          isClipboardPipeline: !0
        });
        n.fire("clipboardOutput", {
          dataTransfer: i.dataTransfer,
          content: l,
          method: i.method
        });
      }, {
        priority: "low"
      }), this.listenTo(n, "clipboardOutput", function (o, i) {
        i.content.isEmpty || (i.dataTransfer.setData("text/html", _this0.editor.data.htmlProcessor.toData(i.content)), i.dataTransfer.setData("text/plain", H(e.data.htmlProcessor.domConverter, i.content)), i.dataTransfer.setData("application/ckeditor5-editor-id", _this0.editor.id)), i.method == "cut" && e.model.deleteContent(t.selection);
      }, {
        priority: "low"
      });
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "ClipboardPipeline";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }, {
    key: "requires",
    get: function get() {
      return [G];
    }
  }]);
}(b);
var P = re("px");
var me = /*#__PURE__*/function (_le) {
  function me() {
    var _this1;
    _classCallCheck(this, me);
    _this1 = _callSuper(this, me);
    var e = _this1.bindTemplate;
    _this1.set({
      isVisible: !1,
      left: null,
      top: null,
      width: null
    }), _this1.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-clipboard-drop-target-line", e.if("isVisible", "ck-hidden", function (t) {
          return !t;
        })],
        style: {
          left: e.to("left", function (t) {
            return P(t);
          }),
          top: e.to("top", function (t) {
            return P(t);
          }),
          width: e.to("width", function (t) {
            return P(t);
          })
        }
      }
    });
    return _this1;
  }
  _inherits(me, _le);
  return _createClass(me);
}(le);
var E = /*#__PURE__*/function (_b3) {
  function E() {
    var _this10;
    _classCallCheck(this, E);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this10 = _callSuper(this, E, [].concat(args));
    _defineProperty(_this10, "removeDropMarkerDelayed", j(function () {
      return _this10.removeDropMarker();
    }, 40));
    _defineProperty(_this10, "_updateDropMarkerThrottled", V(function (e) {
      return _this10._updateDropMarker(e);
    }, 40));
    _defineProperty(_this10, "_reconvertMarkerThrottled", V(function () {
      _this10.editor.model.markers.has("drop-target") && _this10.editor.editing.reconvertMarker("drop-target");
    }, 0));
    _defineProperty(_this10, "_dropTargetLineView", new me());
    _defineProperty(_this10, "_domEmitter", new (A())());
    _defineProperty(_this10, "_scrollables", new Map());
    return _this10;
  }
  _inherits(E, _b3);
  return _createClass(E, [{
    key: "init",
    value: function init() {
      this._setupDropMarker();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._domEmitter.stopListening();
      var _iterator8 = _createForOfIteratorHelper(this._scrollables.values()),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _ref11 = _step8.value;
          var e = _ref11.resizeObserver;
          e.destroy();
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      return this._updateDropMarkerThrottled.cancel(), this.removeDropMarkerDelayed.cancel(), this._reconvertMarkerThrottled.cancel(), _superPropGet(E, "destroy", this, 3)([]);
    }
  }, {
    key: "updateDropMarker",
    value: function updateDropMarker(e, t, r, n, s, o) {
      this.removeDropMarkerDelayed.cancel();
      var i = U(this.editor, e, t, r, n, s, o); /* istanbul ignore next -- @preserve */
      if (i) {
        if (o && o.containsRange(i)) return this.removeDropMarker();
        this._updateDropMarkerThrottled(i);
      }
    }
  }, {
    key: "getFinalDropRange",
    value: function getFinalDropRange(e, t, r, n, s, o) {
      var i = U(this.editor, e, t, r, n, s, o);
      return this.removeDropMarker(), i;
    }
  }, {
    key: "removeDropMarker",
    value: function removeDropMarker() {
      var e = this.editor.model;
      this.removeDropMarkerDelayed.cancel(), this._updateDropMarkerThrottled.cancel(), this._dropTargetLineView.isVisible = !1, e.markers.has("drop-target") && e.change(function (t) {
        t.removeMarker("drop-target");
      });
    }
  }, {
    key: "_setupDropMarker",
    value: function _setupDropMarker() {
      var _this11 = this;
      var e = this.editor;
      e.ui.view.body.add(this._dropTargetLineView), e.conversion.for("editingDowncast").markerToHighlight({
        model: "drop-target",
        view: {
          classes: ["ck-clipboard-drop-target-range"]
        }
      }), e.conversion.for("editingDowncast").markerToElement({
        model: "drop-target",
        view: function view(t, _ref12) {
          var r = _ref12.writer;
          if (e.model.schema.checkChild(t.markerRange.start, "$text")) return _this11._dropTargetLineView.isVisible = !1, _this11._createDropTargetPosition(r);
          t.markerRange.isCollapsed ? _this11._updateDropTargetLine(t.markerRange) : _this11._dropTargetLineView.isVisible = !1;
        }
      });
    }
  }, {
    key: "_updateDropMarker",
    value: function _updateDropMarker(e) {
      var t = this.editor,
        r = t.model.markers;
      t.model.change(function (n) {
        r.has("drop-target") ? r.get("drop-target").getRange().isEqual(e) || n.updateMarker("drop-target", {
          range: e
        }) : n.addMarker("drop-target", {
          range: e,
          usingOperation: !1,
          affectsData: !1
        });
      });
    }
  }, {
    key: "_createDropTargetPosition",
    value: function _createDropTargetPosition(e) {
      return e.createUIElement("span", {
        class: "ck ck-clipboard-drop-target-position"
      }, function (t) {
        var r = this.toDomElement(t);
        return r.append("⁠", t.createElement("span"), "⁠"), r;
      });
    }
  }, {
    key: "_updateDropTargetLine",
    value: function _updateDropTargetLine(e) {
      var t = this.editor.editing,
        r = e.start.nodeBefore,
        n = e.start.nodeAfter,
        s = e.start.parent,
        o = r ? t.mapper.toViewElement(r) : null,
        i = o ? t.view.domConverter.mapViewToDom(o) : null,
        l = n ? t.mapper.toViewElement(n) : null,
        c = l ? t.view.domConverter.mapViewToDom(l) : null,
        d = t.mapper.toViewElement(s);
      if (!d) return;
      var g = t.view.domConverter.mapViewToDom(d),
        p = this._getScrollableRect(d),
        _m$window = m.window,
        u = _m$window.scrollX,
        h = _m$window.scrollY,
        M = i ? new _(i) : null,
        S = c ? new _(c) : null,
        D = new _(g).excludeScrollbarsAndBorders(),
        O = M ? M.bottom : D.top,
        C = S ? S.top : D.bottom,
        I = m.window.getComputedStyle(g),
        R = O <= C ? (O + C) / 2 : C;
      if (p.top < R && R < p.bottom) {
        var J = D.left + parseFloat(I.paddingLeft),
          Q = D.right - parseFloat(I.paddingRight),
          F = Math.max(J + u, p.left),
          Z = Math.min(Q + u, p.right);
        this._dropTargetLineView.set({
          isVisible: !0,
          left: F,
          top: R + h,
          width: Z - F
        });
      } else this._dropTargetLineView.isVisible = !1;
    }
  }, {
    key: "_getScrollableRect",
    value: function _getScrollableRect(e) {
      var t = e.root.rootName;
      var r;
      if (this._scrollables.has(t)) r = this._scrollables.get(t).domElement;else {
        var n = this.editor.editing.view.domConverter.mapViewToDom(e);
        r = he(n), this._domEmitter.listenTo(r, "scroll", this._reconvertMarkerThrottled, {
          usePassive: !0
        });
        var s = new te(r, this._reconvertMarkerThrottled);
        this._scrollables.set(t, {
          domElement: r,
          resizeObserver: s
        });
      }
      return new _(r).excludeScrollbarsAndBorders();
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "DragDropTarget";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(b);
function U(a, e, t, r, n, s, o) {
  var i = a.model,
    l = a.editing.mapper;
  var d = $(a, e);
  var _loop2 = function _loop2() {
      if (!s) {
        if (i.schema.checkChild(d, "$text")) {
          if (t) {
            var g = t[0].start,
              p = l.toModelPosition(g);
            if (!o || Array.from(o.getItems({
              shallow: !0
            })).every(function (h) {
              return i.schema.checkChild(p, h);
            })) {
              if (i.schema.checkChild(p, "$text")) return {
                v: i.createRange(p)
              };
              if (g) return {
                v: w(a, $(a, g.parent), r, n)
              };
            }
          }
        } else if (i.schema.isInline(d)) return {
          v: w(a, d, r, n)
        };
      }
      if (i.schema.isBlock(d)) return {
        v: w(a, d, r, n)
      };
      if (i.schema.checkChild(d, "$block")) {
        var _g = Array.from(d.getChildren()).filter(function (h) {
          return h.is("element") && !ue(a, h);
        });
        var _p = 0,
          u = _g.length;
        if (u == 0) return {
          v: i.createRange(i.createPositionAt(d, "end"))
        };
        for (; _p < u - 1;) {
          var h = Math.floor((_p + u) / 2);
          X(a, _g[h], r, n) == "before" ? u = h : _p = h;
        }
        return {
          v: w(a, _g[_p], r, n)
        };
      }
      d = d.parent;
    },
    _ret;
  for (; d;) {
    _ret = _loop2();
    if (_ret) return _ret.v;
  }
  return null;
}
function ue(a, e) {
  var t = a.editing.mapper,
    r = a.editing.view.domConverter,
    n = t.toViewElement(e);
  if (!n) return !0;
  var s = r.mapViewToDom(n);
  return m.window.getComputedStyle(s).float != "none";
}
function w(a, e, t, r) {
  var n = a.model;
  return n.createRange(n.createPositionAt(e, X(a, e, t, r)));
}
function X(a, e, t, r) {
  var n = a.editing.mapper,
    s = a.editing.view.domConverter,
    o = n.toViewElement(e),
    i = s.mapViewToDom(o),
    l = new _(i);
  return a.model.schema.isInline(e) ? t < (l.left + l.right) / 2 ? "before" : "after" : r < (l.top + l.bottom) / 2 ? "before" : "after";
}
function $(a, e) {
  var t = a.editing.mapper,
    r = a.editing.view,
    n = t.toModelElement(e);
  if (n) return n;
  var s = r.createPositionBefore(e),
    o = t.findMappedViewAncestor(s);
  return t.toModelElement(o);
}
function he(a) {
  var e = a;
  do {
    e = e.parentElement;
    var t = m.window.getComputedStyle(e).overflowY;
    if (t == "auto" || t == "scroll") break;
  } while (e.tagName != "BODY");
  return e;
}
var fe = /*#__PURE__*/function (_b4) {
  function fe() {
    var _this12;
    _classCallCheck(this, fe);
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    _this12 = _callSuper(this, fe, [].concat(args));
    _defineProperty(_this12, "_isBlockDragging", !1);
    _defineProperty(_this12, "_domEmitter", new (A())());
    return _this12;
  }
  _inherits(fe, _b4);
  return _createClass(fe, [{
    key: "init",
    value: function init() {
      var _this13 = this;
      var e = this.editor;
      if (this.listenTo(e, "change:isReadOnly", function (t, r, n) {
        n ? (_this13.forceDisabled("readOnlyMode"), _this13._isBlockDragging = !1) : _this13.clearForceDisabled("readOnlyMode");
      }), f.isAndroid && this.forceDisabled("noAndroidSupport"), e.plugins.has("BlockToolbar")) {
        var r = e.plugins.get("BlockToolbar").buttonView.element;
        this._domEmitter.listenTo(r, "dragstart", function (n, s) {
          return _this13._handleBlockDragStart(s);
        }), this._domEmitter.listenTo(m.document, "dragover", function (n, s) {
          return _this13._handleBlockDragging(s);
        }), this._domEmitter.listenTo(m.document, "drop", function (n, s) {
          return _this13._handleBlockDragging(s);
        }), this._domEmitter.listenTo(m.document, "dragend", function () {
          return _this13._handleBlockDragEnd();
        }, {
          useCapture: !0
        }), this.isEnabled && r.setAttribute("draggable", "true"), this.on("change:isEnabled", function (n, s, o) {
          r.setAttribute("draggable", o ? "true" : "false");
        });
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return this._domEmitter.stopListening(), _superPropGet(fe, "destroy", this, 3)([]);
    }
  }, {
    key: "_handleBlockDragStart",
    value: function _handleBlockDragStart(e) {
      if (!this.isEnabled) return;
      var t = this.editor.model,
        r = t.document.selection,
        n = this.editor.editing.view,
        s = Array.from(r.getSelectedBlocks()),
        o = t.createRange(t.createPositionBefore(s[0]), t.createPositionAfter(s[s.length - 1]));
      t.change(function (i) {
        return i.setSelection(o);
      }), this._isBlockDragging = !0, n.focus(), n.getObserver(v).onDomEvent(e);
    }
  }, {
    key: "_handleBlockDragging",
    value: function _handleBlockDragging(e) {
      if (!this.isEnabled || !this._isBlockDragging) return;
      var t = e.clientX + (this.editor.locale.contentLanguageDirection == "ltr" ? 100 : -100),
        r = e.clientY,
        n = document.elementFromPoint(t, r),
        s = this.editor.editing.view;
      !n || !n.closest(".ck-editor__editable") || s.getObserver(v).onDomEvent(_objectSpread(_objectSpread({}, e), {}, {
        type: e.type,
        dataTransfer: e.dataTransfer,
        target: n,
        clientX: t,
        clientY: r,
        preventDefault: function preventDefault() {
          return e.preventDefault();
        },
        stopPropagation: function stopPropagation() {
          return e.stopPropagation();
        }
      }));
    }
  }, {
    key: "_handleBlockDragEnd",
    value: function _handleBlockDragEnd() {
      this._isBlockDragging = !1;
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "DragDropBlockToolbar";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(b);
var be = /*#__PURE__*/function (_b5) {
  function be() {
    var _this14;
    _classCallCheck(this, be);
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    _this14 = _callSuper(this, be, [].concat(args));
    _defineProperty(_this14, "_draggedRange", void 0);
    _defineProperty(_this14, "_draggingUid", void 0);
    _defineProperty(_this14, "_draggableElement", void 0);
    _defineProperty(_this14, "_clearDraggableAttributesDelayed", j(function () {
      return _this14._clearDraggableAttributes();
    }, 40));
    _defineProperty(_this14, "_blockMode", !1);
    _defineProperty(_this14, "_domEmitter", new (A())());
    _defineProperty(_this14, "_previewContainer", void 0);
    return _this14;
  }
  _inherits(be, _b5);
  return _createClass(be, [{
    key: "init",
    value: function init() {
      var _this15 = this;
      var e = this.editor,
        t = e.editing.view;
      this._draggedRange = null, this._draggingUid = "", this._draggableElement = null, t.addObserver(v), t.addObserver(ne), this._setupDragging(), this._setupContentInsertionIntegration(), this._setupClipboardInputIntegration(), this._setupDraggableAttributeHandling(), this.listenTo(e, "change:isReadOnly", function (r, n, s) {
        s ? _this15.forceDisabled("readOnlyMode") : _this15.clearForceDisabled("readOnlyMode");
      }), this.on("change:isEnabled", function (r, n, s) {
        s || _this15._finalizeDragging(!1);
      }), f.isAndroid && this.forceDisabled("noAndroidSupport");
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return this._draggedRange && (this._draggedRange.detach(), this._draggedRange = null), this._previewContainer && this._previewContainer.remove(), this._domEmitter.stopListening(), this._clearDraggableAttributesDelayed.cancel(), _superPropGet(be, "destroy", this, 3)([]);
    }
  }, {
    key: "_setupDragging",
    value: function _setupDragging() {
      var _this16 = this;
      var e = this.editor,
        t = e.model,
        r = e.editing.view,
        n = r.document,
        s = e.plugins.get(E);
      this.listenTo(n, "dragstart", function (o, i) {
        var _i$target;
        if ((_i$target = i.target) !== null && _i$target !== void 0 && _i$target.is("editableElement")) {
          i.preventDefault();
          return;
        }
        if (_this16._prepareDraggedRange(i.target), !_this16._draggedRange) {
          i.preventDefault();
          return;
        }
        _this16._draggingUid = z(), i.dataTransfer.effectAllowed = _this16.isEnabled ? "copyMove" : "copy", i.dataTransfer.setData("application/ckeditor5-dragging-uid", _this16._draggingUid);
        var l = t.createSelection(_this16._draggedRange.toRange());
        _this16.editor.plugins.get("ClipboardPipeline")._fireOutputTransformationEvent(i.dataTransfer, l, "dragstart");
        var d = i.dataTransfer,
          g = i.domTarget,
          p = i.domEvent,
          u = p.clientX;
        _this16._updatePreview({
          dataTransfer: d,
          domTarget: g,
          clientX: u
        }), i.stopPropagation(), _this16.isEnabled || (_this16._draggedRange.detach(), _this16._draggedRange = null, _this16._draggingUid = "");
      }, {
        priority: "low"
      }), this.listenTo(n, "dragend", function (o, i) {
        _this16._finalizeDragging(!i.dataTransfer.isCanceled && i.dataTransfer.dropEffect == "move");
      }, {
        priority: "low"
      }), this._domEmitter.listenTo(m.document, "dragend", function () {
        _this16._blockMode = !1;
      }, {
        useCapture: !0
      }), this.listenTo(n, "dragenter", function () {
        _this16.isEnabled && r.focus();
      }), this.listenTo(n, "dragleave", function () {
        s.removeDropMarkerDelayed();
      }), this.listenTo(n, "dragging", function (o, i) {
        if (!_this16.isEnabled) {
          i.dataTransfer.dropEffect = "none";
          return;
        }
        var _i$domEvent = i.domEvent,
          l = _i$domEvent.clientX,
          c = _i$domEvent.clientY;
        s.updateDropMarker(i.target, i.targetRanges, l, c, _this16._blockMode, _this16._draggedRange), _this16._draggedRange || (i.dataTransfer.dropEffect = "copy"), f.isGecko || (i.dataTransfer.effectAllowed == "copy" ? i.dataTransfer.dropEffect = "copy" : ["all", "copyMove"].includes(i.dataTransfer.effectAllowed) && (i.dataTransfer.dropEffect = "move")), o.stop();
      }, {
        priority: "low"
      });
    }
  }, {
    key: "_setupClipboardInputIntegration",
    value: function _setupClipboardInputIntegration() {
      var _this17 = this;
      var e = this.editor,
        r = e.editing.view.document,
        n = e.plugins.get(E);
      this.listenTo(r, "clipboardInput", function (s, o) {
        if (o.method != "drop") return;
        var _o$domEvent = o.domEvent,
          i = _o$domEvent.clientX,
          l = _o$domEvent.clientY,
          c = n.getFinalDropRange(o.target, o.targetRanges, i, l, _this17._blockMode, _this17._draggedRange);
        if (!c) {
          _this17._finalizeDragging(!1), s.stop();
          return;
        }
        if (_this17._draggedRange && _this17._draggingUid != o.dataTransfer.getData("application/ckeditor5-dragging-uid") && (_this17._draggedRange.detach(), _this17._draggedRange = null, _this17._draggingUid = ""), N(o.dataTransfer) == "move" && _this17._draggedRange && _this17._draggedRange.containsRange(c, !0)) {
          _this17._finalizeDragging(!1), s.stop();
          return;
        }
        o.targetRanges = [e.editing.mapper.toViewRange(c)];
      }, {
        priority: "high"
      });
    }
  }, {
    key: "_setupContentInsertionIntegration",
    value: function _setupContentInsertionIntegration() {
      var _this18 = this;
      var e = this.editor.plugins.get(y);
      e.on("contentInsertion", function (t, r) {
        if (!_this18.isEnabled || r.method !== "drop") return;
        var n = r.targetRanges.map(function (s) {
          return _this18.editor.editing.mapper.toModelRange(s);
        });
        _this18.editor.model.change(function (s) {
          return s.setSelection(n);
        });
      }, {
        priority: "high"
      }), e.on("contentInsertion", function (t, r) {
        if (!_this18.isEnabled || r.method !== "drop") return;
        var n = N(r.dataTransfer) == "move",
          s = !r.resultRange || !r.resultRange.isCollapsed;
        _this18._finalizeDragging(s && n);
      }, {
        priority: "lowest"
      });
    }
  }, {
    key: "_setupDraggableAttributeHandling",
    value: function _setupDraggableAttributeHandling() {
      var _this19 = this;
      var e = this.editor,
        t = e.editing.view,
        r = t.document;
      this.listenTo(r, "mousedown", function (n, s) {
        if (f.isAndroid || !s) return;
        _this19._clearDraggableAttributesDelayed.cancel();
        var o = W(s.target);
        if (f.isBlink && !e.isReadOnly && !o && !r.selection.isCollapsed) {
          var i = r.selection.getSelectedElement();
          (!i || !k(i)) && (o = r.selection.editableElement);
        }
        o && (t.change(function (i) {
          i.setAttribute("draggable", "true", o);
        }), _this19._draggableElement = e.editing.mapper.toModelElement(o));
      }), this.listenTo(r, "mouseup", function () {
        f.isAndroid || _this19._clearDraggableAttributesDelayed();
      });
    }
  }, {
    key: "_clearDraggableAttributes",
    value: function _clearDraggableAttributes() {
      var _this20 = this;
      var e = this.editor.editing;
      e.view.change(function (t) {
        _this20._draggableElement && _this20._draggableElement.root.rootName != "$graveyard" && t.removeAttribute("draggable", e.mapper.toViewElement(_this20._draggableElement)), _this20._draggableElement = null;
      });
    }
  }, {
    key: "_finalizeDragging",
    value: function _finalizeDragging(e) {
      var _this21 = this;
      var t = this.editor,
        r = t.model;
      t.plugins.get(E).removeDropMarker(), this._clearDraggableAttributes(), t.plugins.has("WidgetToolbarRepository") && t.plugins.get("WidgetToolbarRepository").clearForceDisabled("dragDrop"), this._draggingUid = "", this._previewContainer && (this._previewContainer.remove(), this._previewContainer = void 0), this._draggedRange && (e && this.isEnabled && r.change(function (s) {
        var o = r.createSelection(_this21._draggedRange);
        r.deleteContent(o, {
          doNotAutoparagraph: !0
        });
        var i = o.getFirstPosition().parent;
        i.isEmpty && !r.schema.checkChild(i, "$text") && r.schema.checkChild(i, "paragraph") && s.insertElement("paragraph", i, 0);
      }), this._draggedRange.detach(), this._draggedRange = null);
    }
  }, {
    key: "_prepareDraggedRange",
    value: function _prepareDraggedRange(e) {
      var _this22 = this;
      var t = this.editor,
        r = t.model,
        n = r.document.selection,
        s = e ? W(e) : null;
      if (s) {
        var c = t.editing.mapper.toModelElement(s);
        this._draggedRange = T.fromRange(r.createRangeOn(c)), this._blockMode = r.schema.isBlock(c), t.plugins.has("WidgetToolbarRepository") && t.plugins.get("WidgetToolbarRepository").forceDisabled("dragDrop");
        return;
      }
      if (n.isCollapsed && !n.getFirstPosition().parent.isEmpty) return;
      var o = Array.from(n.getSelectedBlocks()),
        i = n.getFirstRange();
      if (o.length == 0) {
        this._draggedRange = T.fromRange(i);
        return;
      }
      var l = Y(r, o);
      if (o.length > 1) this._draggedRange = T.fromRange(l), this._blockMode = !0;else if (o.length == 1) {
        var _c2 = i.start.isTouching(l.start) && i.end.isTouching(l.end);
        this._draggedRange = T.fromRange(_c2 ? l : i), this._blockMode = _c2;
      }
      r.change(function (c) {
        return c.setSelection(_this22._draggedRange.toRange());
      });
    }
  }, {
    key: "_updatePreview",
    value: function _updatePreview(_ref13) {
      var e = _ref13.dataTransfer,
        t = _ref13.domTarget,
        r = _ref13.clientX;
      var n = this.editor.editing.view,
        s = n.document.selection.editableElement,
        o = n.domConverter.mapViewToDom(s),
        i = m.window.getComputedStyle(o);
      this._previewContainer ? this._previewContainer.firstElementChild && this._previewContainer.removeChild(this._previewContainer.firstElementChild) : (this._previewContainer = x(m.document, "div", {
        style: "position: fixed; left: -999999px;"
      }), m.document.body.appendChild(this._previewContainer));
      var l = new _(o);
      if (o.contains(t)) return;
      var c = parseFloat(i.paddingLeft),
        d = x(m.document, "div");
      d.className = "ck ck-content", d.style.width = i.width, d.style.paddingLeft = "".concat(l.left - r + c, "px"), f.isiOS && (d.style.backgroundColor = "white"), n.domConverter.setContentOf(d, e.getData("text/html")), e.setDragImage(d, 0, 0), this._previewContainer.appendChild(d);
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "DragDrop";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }, {
    key: "requires",
    get: function get() {
      return [y, ae, E, fe];
    }
  }]);
}(b);
function N(a) {
  return f.isGecko ? a.dropEffect : ["all", "copyMove"].includes(a.effectAllowed) ? "move" : "copy";
}
function W(a) {
  if (a.is("editableElement")) return null;
  if (a.hasClass("ck-widget__selection-handle")) return a.findAncestor(k);
  if (k(a)) return a;
  var e = a.findAncestor(function (t) {
    return k(t) || t.is("editableElement");
  });
  return k(e) ? e : null;
}
function Y(a, e) {
  var t = e[0],
    r = e[e.length - 1],
    n = t.getCommonAncestor(r),
    s = a.createPositionBefore(t),
    o = a.createPositionAfter(r);
  if (n && n.is("element") && !a.schema.isLimit(n)) {
    var i = a.createRangeOn(n),
      l = s.isTouching(i.start),
      c = o.isTouching(i.end);
    if (l && c) return Y(a, [n]);
  }
  return a.createRange(s, o);
}
var _e = /*#__PURE__*/function (_b6) {
  function _e() {
    _classCallCheck(this, _e);
    return _callSuper(this, _e, arguments);
  }
  _inherits(_e, _b6);
  return _createClass(_e, [{
    key: "init",
    value: function init() {
      var e = this.editor,
        t = e.model,
        r = e.editing.view,
        n = t.document.selection;
      r.addObserver(v), e.plugins.get(y).on("contentInsertion", function (s, o) {
        ke(o.content, t) && t.change(function (i) {
          var l = Array.from(n.getAttributes()).filter(function (_ref14) {
            var _ref15 = _slicedToArray(_ref14, 1),
              d = _ref15[0];
            return t.schema.getAttributeProperties(d).isFormatting;
          });
          n.isCollapsed || t.deleteContent(n, {
            doNotAutoparagraph: !0
          }), l.push.apply(l, _toConsumableArray(n.getAttributes()));
          var c = i.createRangeIn(o.content);
          var _iterator9 = _createForOfIteratorHelper(c.getItems()),
            _step9;
          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var d = _step9.value;
              var _iterator0 = _createForOfIteratorHelper(l),
                _step0;
              try {
                for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
                  var g = _step0.value;
                  t.schema.checkAttribute(d, g[0]) && i.setAttribute(g[0], g[1], d);
                }
              } catch (err) {
                _iterator0.e(err);
              } finally {
                _iterator0.f();
              }
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }
        });
      });
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "PastePlainText";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }, {
    key: "requires",
    get: function get() {
      return [y];
    }
  }]);
}(b);
function ke(a, e) {
  var t = e.createRangeIn(a);
  if (a.childCount == 1) {
    var r = a.getChild(0);
    r.is("element") && e.schema.isBlock(r) && !e.schema.isObject(r) && !e.schema.isLimit(r) && (t = e.createRangeIn(r));
  }
  var _iterator1 = _createForOfIteratorHelper(t.getItems()),
    _step1;
  try {
    for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
      var _r = _step1.value;
      if (!e.schema.isInline(_r) || Array.from(_r.getAttributeKeys()).find(function (s) {
        return e.schema.getAttributeProperties(s).isFormatting;
      })) return !1;
    }
  } catch (err) {
    _iterator1.e(err);
  } finally {
    _iterator1.f();
  }
  return !0;
}
var Ce = /*#__PURE__*/function (_b7) {
  function Ce() {
    _classCallCheck(this, Ce);
    return _callSuper(this, Ce, arguments);
  }
  _inherits(Ce, _b7);
  return _createClass(Ce, [{
    key: "init",
    value: function init() {
      var e = this.editor,
        t = this.editor.t;
      e.accessibility.addKeystrokeInfos({
        keystrokes: [{
          label: t("Copy selected content"),
          keystroke: "CTRL+C"
        }, {
          label: t("Paste content"),
          keystroke: "CTRL+V"
        }, {
          label: t("Paste content as plain text"),
          keystroke: "CTRL+SHIFT+V"
        }]
      });
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "Clipboard";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }, {
    key: "requires",
    get: function get() {
      return [G, y, be, _e];
    }
  }]);
}(b);
export { Ce as Clipboard, G as ClipboardMarkersUtils, v as ClipboardObserver, y as ClipboardPipeline, be as DragDrop, fe as DragDropBlockToolbar, E as DragDropTarget, _e as PastePlainText, de as plainTextToHtml, H as viewToPlainText };